import { useEffect, useState } from 'react';

export default function useProtectedValue<T>(initialValue: T): [
	{ value: T; initialValue: T; dirty: boolean; changed: boolean; touched: boolean },
	{
		setValue: (value: T) => void;
		setDirty: (dirty: boolean) => void;
		setChanged: (changed: boolean) => void;
		setTouched: (touched: boolean) => void;
		reset: () => void;
	},
] {
	const [changed, setChanged] = useState(false);
	const [touched, setTouched] = useState(false);
	const [value, setValue] = useState<T>(initialValue);
	const [dirty, setDirty] = useState(false);

	useEffect(() => {
		const handler = (event: BeforeUnloadEvent) => {
			if (dirty) {
				event.preventDefault();
				event.returnValue = true;
			}
		};
		window.addEventListener('beforeunload', handler);

		return () => window.removeEventListener('beforeunload', handler);
	}, [dirty]);

	return [
		{ value, dirty, changed, initialValue, touched },
		{
			setValue: (value: T) => {
				setValue(value);
				setChanged(true);
				setTouched(true);
			},
			setDirty: (dirty: boolean) => {
				setDirty(dirty);
				setChanged(true);
				setTouched(true);
			},
			setChanged,
			setTouched,
			reset() {
				setValue(initialValue);
				setDirty(false);
				setChanged(false);
			},
		},
	];
}
